// extracted by mini-css-extract-plugin
export default {"sectionTitle":"price_sectionTitle__NGzYz","priceRangeWrapper":"price_priceRangeWrapper__I2KFZ","priceRange":"price_priceRange__-9fKy","priceDisplay":"price_priceDisplay__fv16r"};